import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIInlineFormContext} from "./inline-form-context";

@Component({
    selector: "fui-inline-form-context",
    template: "<ng-content></ng-content>",
    providers: [{provide: FUIFormContext, useClass: FUIInlineFormContext}]
})
export class FUIInlineFormContextComponent {
}
